import { validateAFM, validSumPercentage } from 'utils';
import { countries } from 'utils/countries';

export const carrierShareHoldersFields = [
  {
    label: 'Ονοματεπώνυμο Εταίρου / Μετόχου',
    type: 'text',
    name: 'shareHolderName',
    id: 'shareHolderName',
    size: 'large',
    placeholder: 'Εισάγετε Ονοματεπώνυμο Εταίρου / Μετόχου',
    span: 9,
    asterisk: true,
    maxLength: 80,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Α.Φ.Μ.',
    type: 'text',
    name: 'shareHolderVat',
    id: 'shareHolderVat',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    maxLength: 12,
    span: 3,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validateAFM(value);
        },
      }),
    ],
  },
  {
    title: 'Χώρα Εγκατάστασης',
    label: 'Χώρα Εγκατάστασης',
    type: 'select',
    name: 'shareHolderCountry',
    id: 'shareHolderCountry',
    showSearch: true,
    className: 'shareHolderSelectCountry',
    options: [
      ...countries.map(b => ({
        value: b.value,
      })),
    ],
    size: 'medium',
    placeholder: 'Επιλέξτε Χώρα',
    maxLength: 12,
    span: 8,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: '% Συμμετοχής',
    type: 'numberWithDecimals',
    name: 'percentage',
    id: 'percentage',
    suffix: '%',
    size: 'large',
    placeholder: '%',
    maxLength: 12,
    decimalsLimit: 15,
    span: 3,
    className: 'shareHolderPercentage',
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validSumPercentage(value);
        },
      }),
    ],
  },
];
